var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"loading"}):_vm._e(),_c('notification-modal',{attrs:{"data":_vm.notification}}),_c('keep-alive',{attrs:{"include":_vm.cachedComponents}},[_c('router-view')],1),_c('ChatbotButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }